import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import WebData from "../../../../Helpers/WebData";
import { Form, Row, Col } from "react-bootstrap";
import PhoneInput, { parsePhoneNumber } from "react-phone-number-input";

const OnsiteVolunteerForm = () => {
  const [formData, setFormData] = useState();
  const [wordCount, setWordCount] = useState(0);
  const [showSkills, setShowSkills] = useState(false);
  const skillsDropdown = useRef();
  const [skills, setskills] = useState([]);
  const [change, setchange] = useState(false);
  const [success, setsuccess] = useState(false);
  const [cv, setcv] = useState();
  const [name, setname] = useState();
  const [loading, setloading] = useState(false);
  const onsiteVolunteer = JSON.parse(localStorage.getItem("OnsiteVolunteer"));

  const formHandler = (e) => {
    let inputValue = e.target.value;
    if (e.target.name === "message" && inputValue.length <= 200) {
      setWordCount(inputValue.length);
    } else if (e.target.name === "message" && inputValue.length > 200) {
      return false;
    }
    setFormData({ ...formData, [e.target.name]: inputValue });
  };

  if (formData) {
    localStorage.setItem("OnsiteVolunteer", JSON.stringify(formData));
  }

  useEffect(() => {
    if (onsiteVolunteer) {
      setFormData(onsiteVolunteer);
    }
  }, []);

  const phoneHandler = (v) => {
    setFormData({ ...formData, contact: v });
  };

  const submitOnsiteVolunteerForm = async (event) => {
    event.preventDefault();
    var form = document.getElementById("onsiteVolunteerForm");
    form.classList.add("was-validated");
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      const data = new FormData();
      data.append("name", formData.name);
      data.append("contact", formData.contact);
      data.append("email", formData.email);
      data.append("country", parsePhoneNumber(formData.contact).country);
      data.append("duration", formData.duration);
      data.append("skills", skills.join(","));
      data.append("cv", cv);
      data.append("message", formData.message);
      data.append("type", "Onsite Volunteer");
      axios
        .post("https://animal-ngo.herokuapp.com/application/send", data, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => alert(res.data))
        .catch((err) => alert(err.response.data));
    }
  };

  const handleClick = (e) => {
    if (!skillsDropdown.current?.contains(e.target)) {
      setShowSkills(false);
    }
  };

  window.addEventListener("mousedown", handleClick, false);

  window.addEventListener("scroll", () => {
    setShowSkills(false);
  });

  const skills_changed = (e) => {
    const parent = e.target.parentNode;
    var s = skills;
    if (e.target.checked) {
      s.push(
        parent.getElementsByClassName("custom-control-label")[0].textContent
      );
    } else {
      var index = s.indexOf(e.target.value);
      s.splice(index, 1);
    }
    setskills(s);
  };

  const change_file = (e) => {
    if (e.target.files) {
      if (e.target.files[0].size <= 204800) {
        setcv(e.target.files[0]);
      } else {
        alert("file must be less then 200KB");
      }
    } else {
      setcv(null);
    }
  };

  return (
    <>
      <div className="form-wrapper">
        <div className="form-container scrollbar-hide form-container-gm">
          <Form
            onSubmit={submitOnsiteVolunteerForm}
            className="needs-validation w-100"
            id="onsiteVolunteerForm"
            noValidate
          >
            <Row className="mb-2">
              <Form.Group as={Col}>
                <Form.Control
                  name="name"
                  value={formData ? formData.name : ""}
                  type="text"
                  placeholder="Full Name*"
                  onChange={formHandler}
                  required
                />
              </Form.Group>
            </Row>
            <Row className="mb-2">
              <Form.Group as={Col}>
                <PhoneInput
                  placeholder="00000 000000"
                  id="phone-input"
                  name="contact"
                  onChange={phoneHandler}
                  international
                  defaultCountry="IN"
                  countryCallingCodeEditable={false}
                  required
                />
              </Form.Group>
            </Row>
            <Row className="mb-2">
              <Form.Group as={Col}>
                <Form.Control
                  name="email"
                  value={formData ? formData.email : ""}
                  type="email"
                  placeholder="Email*"
                  onChange={formHandler}
                  required
                />
              </Form.Group>
            </Row>
            <Row className="mb-2">
              <Form.Group as={Col}>
                <label htmlFor="onsiteVolunteerDuration" className="mb-1">
                  Duration*
                </label>
                <select
                  name="duration"
                  onChange={formHandler}
                  defaultValue=""
                  value={formData && formData.duration}
                  className="form-control "
                  id="onsiteVolunteerDuration"
                  required
                >
                  <option value="" hidden></option>
                  <option value="2 week">2 Weeks</option>
                  <option value="1 month">1 Month</option>
                  <option value="2 month">2 Months</option>
                  <option value="3 month">3 Months</option>
                  <option value="6 month">6 Months</option>
                </select>
              </Form.Group>
            </Row>
            <Row className="mb-2">
              <Form.Group as={Col}>
                <label htmlFor="volunteerSkills" className="mb-1">
                  Skills*
                </label>
                <button
                  className="btn btn-outline-danger w-100 d-flex align-items-center bg-light justify-content-between selectSkillsBtn"
                  type="button"
                  onClick={() => {
                    setShowSkills(true);
                  }}
                >
                  Select Skills <i className="fa fa-chevron-down"></i>
                </button>

                <div
                  className={
                    "skills-dropdown " + (showSkills ? "d-block" : "d-none")
                  }
                  ref={skillsDropdown}
                >
                  {WebData.skillsList.map((skill, index) => {
                    return (
                      <div
                        key={index}
                        className="custom-control custom-checkbox"
                      >
                        <input
                          type="checkbox"
                          onChange={skills_changed}
                          id={`onsiteVolunteer-${skill.name}`}
                          name="skills"
                          className="skills_onsite custom-control-input"
                        />
                        <label
                          className="custom-control-label"
                          htmlFor={`onsiteVolunteer-${skill.name}`}
                        >
                          {skill.name}
                        </label>
                      </div>
                    );
                  })}
                </div>
              </Form.Group>
            </Row>
            <Row className="mb-2">
              <Form.Group as={Col}>
                <label htmlFor="onsiteVolunteerCV" className="mb-1">
                  Upload CV*
                </label>
                <div className="custom-file">
                  <Form.Control
                    type="file"
                    onChange={change_file}
                    id="onsiteVolunteerCV"
                    accept=".docx,.doc,.pdf"
                    required
                  />
                </div>
              </Form.Group>
            </Row>
            <Row className="mb-2">
              <Form.Group as={Col}>
                <textarea
                  name="message"
                  placeholder="Message"
                  className="form-control"
                  onChange={formHandler}
                  value={formData ? formData.message : ""}
                ></textarea>
                <div className="wordCount">{wordCount}/200</div>
              </Form.Group>
            </Row>
            <div className="row d-flex mb-1 justify-content-center">
              <button className="btn submitFormBtn">Submit Application</button>
            </div>
          </Form>
        </div>
      </div>
    </>
  );
};

export default OnsiteVolunteerForm;
